import { useCompanyPreferences } from '@/api/performance-company-preferences';
import { getLocalizedText } from '@/utils/localization';

/**
 * The company's strategic-vision quote, localized: the same `useCompanyPreferences` +
 * `getLocalizedText` pair the Objectives list hero (`ObjectivesPage`), the form's "Vision de
 * l'entreprise" card (`ObjectiveFormPage`) and the pillar modal's "Notre vision partagée" block
 * (`PillarVisionModal`) each used to repeat on their own -- one place instead of three.
 */
export const useStrategicVision = (): string => {
    const { data: preferences } = useCompanyPreferences();

    return getLocalizedText(preferences?.strategicVision);
};
